<template>
  <div class="logistics-wrap">
    <template
      v-if="logistic.id && !['canceled', 'refund'].includes(order.status)"
    >
      <div class="logistics-header">
        <svg-icon :iconClass="payResultIcon" class="icon" />
        <span>{{ orderStatus }}</span>
      </div>
      <div class="logistics-order">
        <div>
          <span class="logistics-order-title">快递单号</span>
          <span class="logistics-order-content">{{ trackingNumber }}</span>
        </div>
        <div v-if="logistic.tracking_number">
          <span class="logistics-order-title">快递公司</span>
          <span class="logistics-order-content">{{
            logistic.express_company
          }}</span>
        </div>
        <div
          class="copy-btn"
          v-if="logistic.tracking_number"
          @click="handleCopy"
        >
          复制
        </div>
      </div>
      <div class="logistics-user-info">
        <div class="address">
          {{ logistic.address }}
        </div>
        <div class="user-info">
          <span>{{ logistic.username }}</span>
          <span>{{ logistic.phone_number }}</span>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="logistics-header">
        <svg-icon iconClass="pay-result-success-gold" class="icon" />
        <span>{{ renderOrderStatusText }}</span>
      </div>
    </template>
  </div>
</template>

<script>
import { defineComponent, computed } from "@vue/composition-api";
import copy from "copy-to-clipboard";
import Vue from "vue";

import { MATTER_ORDER_STATUS } from "@/constants";

const vm = Vue.prototype;

export default defineComponent({
  props: ["logistic", "order"],
  setup(props) {
    const orderStatus = computed(() => {
      return MATTER_ORDER_STATUS[props.logistic.status];
    });

    const trackingNumber = computed(() => {
      return props.logistic.tracking_number
        ? props.logistic.tracking_number
        : "正在出库，暂无快递单号";
    });

    const payResultIcon = computed(() => {
      const { status } = props.logistic;
      if (
        [
          "pending",
          "unpaid",
          "paid",
          "confirming",
          "receiving",
          "received",
        ].includes(status)
      )
        return `pay-result-unpaid-gold`;
      if (["completed", "refund"].includes(status))
        return `pay-result-fail-gold`;
      return `pay-result-success-gold`;
    });

    const renderOrderStatusText = computed(() => {
      const { status } = props.order;
      return (
        {
          canceled: "订单已取消",
          refund: "订单已退款",
        }[status] || "订单已取消"
      );
    });

    const handleCopy = () => {
      copy(props.logistic.tracking_number);
      vm.$toast("复制成功");
    };

    return {
      payResultIcon,
      orderStatus,
      trackingNumber,
      renderOrderStatusText,
      handleCopy,
    };
  },
});
</script>

<style lang="less" scoped>
.logistics-wrap {
  background-color: #fff;
  padding: 12px;
  background: #ffffff;
  border-radius: 8px;
}

.logistics-header {
  display: flex;
  align-items: center;
  .icon {
    height: 24px;
    width: 24px;
  }
  > span {
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    line-height: 24px;
    margin-left: 6px;
  }
}

.logistics-order {
  margin-left: 11px;
  padding: 5px 18px;
  height: 60px;
  box-sizing: border-box;
  border-left: 1px solid #dcdada;
  position: relative;

  > div {
    margin-bottom: 3px;
  }

  .logistics-order-title {
    font-weight: 400;
    font-size: 12px;
    color: #333333;
    line-height: 17px;
  }

  .logistics-order-content {
    margin-left: 12px;
    font-weight: 600;
    font-size: 12px;
    color: #000000;
    line-height: 17px;
  }

  .copy-btn {
    width: 38px;
    height: 20px;
    background: #ffffff;
    border-radius: 11px;
    border: 1px solid #d2d2d2;
    position: absolute;
    right: 12px;
    top: 5px;

    font-weight: 500;
    font-size: 10px;
    color: #999999;
    line-height: 20px;
    text-align: center;
  }
}

.logistics-user-info {
  margin-left: 24px;
  margin-bottom: 12px;
  position: relative;
  margin-top: -6px;

  &::before {
    content: "";
    position: absolute;
    left: -15px;
    top: 6px;
    width: 5px;
    height: 5px;
    background: #d8d8d8;
    border-radius: 50%;
  }
  .address {
    font-weight: 600;
    font-size: 12px;
    color: #000000;
    line-height: 17px;
  }
  .user-info {
    margin-top: 4px;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 17px;

    > span:last-child {
      margin-left: 12px;
    }
  }
}
</style>